import React from 'react';
import PropTypes from 'prop-types';
import styles from './LastUsedIndicator.scss';

export const LastUsedIndicatorVariants = {
    // Social tile: a pale-blue panel behind the tile with the label along its bottom edge.
    TILE: 'tile',
    // Email field: a pill on the field's top-right corner.
    FIELD: 'field',
};

const LAST_USED_LABEL = 'Last Used';

const LastUsedIndicator = ({ variant, children, 'data-testid': dataTestId }) => {
    const isField = variant === LastUsedIndicatorVariants.FIELD;

    return (
        <div className={isField ? styles.fieldWrapper : styles.tileWrapper} data-testid={dataTestId}>
            <div className={isField ? styles.fieldControl : styles.tilePanel} data-variant={variant}>
                {children}
            </div>
            <span
                className={isField ? styles.fieldPill : styles.tileCaption}
                data-testid={dataTestId && `${dataTestId}.caption`}
            >
                {LAST_USED_LABEL}
            </span>
        </div>
    );
};

LastUsedIndicator.propTypes = {
    variant: PropTypes.oneOf(Object.values(LastUsedIndicatorVariants)).isRequired,
    children: PropTypes.node.isRequired,
    'data-testid': PropTypes.string,
};

LastUsedIndicator.defaultProps = {
    'data-testid': null,
};

export default LastUsedIndicator;
